import { SeverityMapper } from '../../mappers/SeverityMapper';
import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { Instance } from '../models/Instance';

export class InstanceMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();
  private readonly severityMapper = new SeverityMapper();

  mapGQLModel(data: any): Instance {
    return new Instance(
      this.gqlIdEncoder.decode(data.id),
      this.severityMapper.mapSeverity(data.severity),
      data.data,
      data.filterStatus,
      data.number,
      data.numberLocal ?? 0,
      data.ruleNumber
    );
  }
}
